export const AGENCIES_URL = 'agency';

export const DSP_AGENCIES_URL = 'dsp-agency';

export const AGENCIES_BY_ROLE_URL = 'dsp-agency/role';

export const ADVERTISERS_URL = 'advertiser';

export const DSP_ADVERTISERS_URL = 'dsp-advertiser';

export const CAMPAIGNS_URL = 'insertion-order';
